import CustomDraggingTable from './CustomDraggingTable'

export default CustomDraggingTable